export const windowSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});
